import { Injectable, ApplicationRef } from '@angular/core';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IdleMessageComponent } from '../components/idle-message/idle-message.component';

@Injectable({
  providedIn: 'root'
})
export class ActivityMonitoringService {

  subjectAMService  = new Subject<ActivityStatus>();
  getAMData$ = this.subjectAMService.asObservable();
  popRef: MatDialogRef<IdleMessageComponent>;
  constructor( private dialog: MatDialog, private appRef: ApplicationRef, ) { }

  setStatus(status: ActivityStatus) {
    this.subjectAMService.next(status);
  }
}

export interface ActivityStatus {
   state: string;
   active?: boolean;
   expires?: string;
   countdown?: number;
}